import { TrackingPageModel } from '../tracking-page.model';
import {
  getAppImage,
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const boxingBull: TrackingPageModel = {
  languageMenu: getLanguageMenu('Source Sans Pro', '#ffffffff'),
  searchPageInput: {
    backgroundColor: '#FFFFFF',
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Source Sans Pro', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Source Sans Pro', '#666666ff')
  },
  background: {
    color: '#f0f0f0ff',
    useBackgroundImage: false,
    imageUrl: getAppImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#d8232fff',
    linksUnderline: false,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#00ccff00',
    trackingNumberField: 'trackingNumber',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Source Sans Pro', '#666666ff')
  },
  orderCard: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#00ccff00',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#5780ff',
    linksUnderline: false,
    ...getFontConfig('Source Sans Pro', '#666666ff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 17,
    ...getFontConfig('Roboto', '#000000ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto Mono', '#000000ff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Source Sans Pro', '#666666ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 14,
    ...getFontConfig('Roboto', '#c97c7cff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#c1c1c1ff',
    borderRadius: 4,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#ed2b2bff',
      borderColor: '#ffffffff',
      borderRadius: 3,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Roboto', '#ffffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#2e406800',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Roboto', '#000000ff')
      },
      info: {
        alignment: 'center',
        fontSize: 14,
        ...getFontConfig('Source Sans Pro', '#666666ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#e22323ff',
    borderColor: '#e81212ff',
    borderRadius: 3,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Roboto', white)
  },
  detailsButton: {
    on: null,
    backgroundColor: '#d8232fff',
    borderColor: '#00ccff00',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Open Sans Condensed', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#d8232fff',
    borderColor: '#ee7227',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Open Sans Condensed', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(
    getAsset('/images/themes/5c98de576af20_checkout-logo-3-180x-2x.png')
  ),
  socialIcons: getSocialIcons(white),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#00ccff00',
    borderRadius: 3,
    borderWidth: 0,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Source Sans Pro', '#666666ff')
  },
  footer: {
    linksColor: '#d8232fff',
    linksUnderline: false,
    backgroundColor: '#f0f0f0ff',
    ...getFooterItems(),
    ...getFontConfig('Source Sans Pro', '#666666')
  },
  header: {
    backgroundColor: '#222222ff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#00ccff00',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#00ccff00',
      borderRadius: 3,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#d8232fff',
        borderColor: '#00ccff00',
        borderRadius: 3,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Source Sans Pro', '#666666ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Source Sans Pro', '#308c18ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d8232fff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#00ccff00',
    borderRadius: 3,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#00ccff00',
      borderRadius: 3,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#d8232fff',
        borderColor: '#00ccff00',
        borderRadius: 3,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Source Sans Pro', '#666666ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto', '#285c2aff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d8232fff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
